import React, {Component} from 'react'
import PropTypes from 'prop-types'
import daDK from 'rc-calendar/lib/locale/da_DK'
import moment from 'moment'
import {Glyphicon} from 'react-bootstrap'
import ToolTip from '../components/ToolTip.js'
import 'moment/locale/en-gb'
import DatePicker from 'rc-calendar/lib/Picker'
import 'rc-calendar/assets/index.css'
import './css/IdeaDueDate.css'
import Calendar from 'rc-calendar'
import VideoModal from '../components/VideoModal'

class IdeaDueDate extends Component {

  constructor(props) {
    super(props)
    this.removeDueDate = this.removeDueDate.bind(this)
    this.disabledDate = this.disabledDate.bind(this)
    this.state = {
      showTime: true,
      showDateInput: true,
      disabled: false,
      value: this.props.selectedDueDate,
    }
  }

    getFormat(time) {
      return 'YYYY-MM-DD'
    }

    onChange = (value) => {
      this.setState({
        value,
      })
      this.props.setDueDate(value)
    }

    disabledDate(current) {
      if (!current) {
        return false
      }
      const date = moment()
      date.hour(0)
      date.minute(0)
      date.second(0)
      date.millisecond(0)
      return current.valueOf() < date.valueOf()
    }

    removeDueDate(){
      this.setState({
        value: null,
      })
      this.props.setDueDate('')
    }

    render() {
      const state = this.state
      let currentDueDate = 'No date selected'
      if (this.props.dueDate && this.props.dueDate!==''){
        currentDueDate = this.props.dueDate
      }
      else {
        currentDueDate = 'No date selected'
      }
      const calendar = (
        <Calendar
          locale={daDK}
          style={{ zIndex: 1000 }}
          dateInputPlaceholder={currentDueDate}
          defaultSelectedValue={this.state.value}
          formatter={this.getFormat(state.showTime)}
          showDateInput={this.state.showDateInput}
          showToday={false}
          disabledDate={this.disabledDate}/>)

      return (<div style={{ width: 400, marginLeft: 0+'px', marginTop: 20+'px' }}>
        <div style={{boxSizing: 'border-box',position: 'relative',display: 'block',lineHeight: 1.5,marginBottom: 22, width: '25vw'}}>
        <h4 style={{display: 'inline-block', marginRight: 5+'px', color: '#3f3f38'}}>Due date:</h4>
          <DatePicker
            animation='slide-up'
            disabled={this.state.disabled}
            calendar={calendar}
            value={this.state.value}
            onChange={this.onChange}>
            {() => {
              return (
                <span tabIndex='0'>
                <input
                  placeholder='Choose a date...'
                  style={{ width: 250, pointer: 'cursor' }}
                  disabled={this.state.disabled}
                  readOnly
                  tabIndex='-1'
                  className='ant-calendar-picker-input ant-input'
                  value={this.props.dueDate}
                  />
                  <VideoModal
                    videoTitle='Due Dates'
                    videoURL='https://www.youtube.com/watch?v=JGiAqBnKNrQ'
                  />
                </span>
              )}
            }
          </DatePicker>
          {this.props.dueDate &&
            <div onClick={() => this.removeDueDate()} className='removeDateButton'>
              <ToolTip tipText='Remove due date'>
                <Glyphicon glyph='trash'/>
              </ToolTip>
            </div>
          }
        </div>
      </div>
  )}
}
IdeaDueDate.propTypes = {
    setDueDate: PropTypes.func.isRequired,
    dueDate: PropTypes.string,
    defaultValue: PropTypes.object,
    defaultCalendarValue: PropTypes.object,
    selectedDueDate: PropTypes.object,
}

export default IdeaDueDate



// WEBPACK FOOTER //
// ./src/components/IdeaDueDate.js